export default __webpack_public_path__ + "static/media/left-arrow.6ea5d4d1.svg";